import React, { useState, useEffect } from "react";
import "./modal.scss";

import SuccessModal from "./SuccessModal";


const Modal = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => {
      setIsOpen(true);
    }, 10);
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setIsOpen(false);
    // Wait for animation to complete before actually closing
    setTimeout(() => {
      props.closeModal();
    }, 400);
  };

  return (
    <div className={`modal ${isOpen ? 'modal-open' : ''} ${isClosing ? 'modal-closing' : ''}`}>
      <div className="backdrop" onClick={handleClose}></div>
      <SuccessModal 
        closeModal={handleClose} 
        link={props.link} 
        service={props.service} 
        client={props.client} 
        tag={props.tag}
        isOpen={isOpen}
        isClosing={isClosing}
      />
    </div>
  );
};

export default Modal;
